import request from '@/utils/request'
const context = require('../context')
const qs = require('qs');

export function fetchIngredientList(params) {
    return request({
        url: context.CATERING + '/Ingredientslnfo/queryByParam',
        method: 'get',
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { arrayFormat: 'repeat' ,skipNulls: true})
        }
    })
}

export function queryByKeyWord(params) {
		return request({
			url: context.CATERING + '/Ingredientslnfo/queryByKeyWord',
			method: 'get',
			params: params
	})
}

export function queryIngredientDetail(params) {
	return request({
			url: context.CATERING + '/Ingredientslnfo/query/'+ params,
			method: 'get'
	})
}

export function loadByIngredientsId(params) {
	return request({
			url: context.CATERING + '/dishes/queryByIngredientsId/',
			method: 'get',
			params: params
	})
}

export function save(params) {
	return request({
			url: context.CATERING + '/Ingredientslnfo/save',
			method: 'post',
			data: params
	})
}

export function update(params) {
	return request({
			url: context.CATERING + '/Ingredientslnfo/update',
			method: 'post',
			data: params
	})
}

export function updateExt(params) {
	return request({
			url: context.CATERING + '/Ingredientslnfo/update/ext',
			method: 'post',
			data: params
	})
}

export function queryBigCate() {
	return request({
			url: context.CATERING + '/Ingredientslnfo/queryBigCate',
			method: 'get'
	})
}

export function querySmallCate(params) {
	return request({
			url: context.CATERING + '/Ingredientslnfo/querySmallCate/'+params,
			method: 'get'
	})
}

export function getUploadUrl() {
	return process.env.BASE_API+ "" + context.CATERING + '/image/upload';
}


// WEBPACK FOOTER //
// ./src/api/catering/ingredient.js